
    import { Options, Vue } from 'vue-class-component';
    import BookingDetails from './BookingForms/BookingDetails.vue'
    import BookingPayment from './BookingForms/BookingPayment.vue'
    import BookingScan from './BookingForms/BookingScan.vue'

    @Options({
        components: {
            BookingDetails,
            BookingPayment,
            BookingScan
        },

        props: {
            // ticketId: {
            //     type: String,
            //     required: true,
            //     default: null
            // }
        },
    
    })
    export default class TicketBooking extends Vue {
        
    }     
   
